// import {store} from './Store/store'
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import Login from '../components/CmpLogin/Login'
import WebsiteView from '../components/CmpLogin/WebsiteView'
// import AnvaHesab from '../components/MnuBasicInfo/CmpAnvaHesab/AnvaHesab'

import PishkhanNetPa from '../components/PishkhanNetPa'
import Accounts from '../components/CmpNetPa/Accounts'
import NetpaHome from '../components/CmpNetPa/NetpaHome'
import PrintBargeSaham from '../components/CmpNetPa/PrintBargeSaham'
import loan from '../components/CmpNetPa/loan'
import Turnover from '../components/CmpNetPa/Turnover'
import Deposit from '../components/CmpNetPa/Deposit'
import Debtor from '../components/CmpNetPa/Debtor'
import Verify from '../components/CmpNetPa/Verify'
import LoanCardex from '../components/CmpNetPa/LoanCardex'
import DebtorReport from '../components/CmpNetPa/DebtorReport'
import UserInfo from '../components/CmpNetPa/UserInfo'
import Accessability from '../components/CmpNetPa/Accessability'
import HampaPay from '../components/CmpNetPa/HampaPay'
import Rememberpassword from '../components/CmpNetPa/Rememberpassword'
import RememberPasswordHampa from '../components/CmpNetPa/RememberPasswordHampa'
import GuaranteeReport from '../components/CmpNetPa/GuaranteeReport'
import BlockedReport from '../components/CmpNetPa/BlockedReport'
import OnlinePaymentReport from '../components/CmpNetPa/OnlinePaymentReport'
import Gateway from '../components/CmpNetPa/Gateway'
import UsersSetting from '../components/CmpNetPa/UsersSetting'
import DepositGroup from '../components/CmpNetPa/DepositGroup'
import Cart from '../components/CmpNetPa/Cart'
import DepositWhithoutLogin from '../components/CmpNetPa/DepositWhithoutLogin'
import TablooElanat from '../components/CmpNetPa/TablooElanat'
import SendMessageToAdmin from '../components/CmpNetPa/SendMessageToAdmin'
import ManagUsers from '../components/CmpNetPa/ManagUsers'
import Register from '../components/CmpNetPa/Register'
import RegisterUser from '../components/CmpNetPa/Register'
import RequestVam from '../components/CmpNetPa/RequestVam'
import loanFollowup from '../components/CmpNetPa/loanFollowup'
import Transfer from '../components/CmpNetPa/Transfer'
import Cheque from '../components/CmpNetPa/Cheque'
import DetailUssd from '../components/CmpNetPa/DetailUssd'
import Transaction from '../components/CmpLogin/Transaction'
import Funds from '../components/CmpNetPa/Funds.vue'
import SafteElectronic from '../components/CmpNetPa/FaraBoom/SafteElectronic.vue'
import WebSiteSetting from '../components/WebSiteSettingComponents/WebSiteSetting.vue'
import AboutUs from '../components/WebSiteSettingComponents/Page/AboutUs.vue'

var axios = require('axios')
var config = {
  method: 'GET',
  url: '/appSettings.json?nocache=123',
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
    'Content-Type': 'application/json',
  },
}

export const routes = [
  {
    path: '',
    component: Login,
    name: 'LoginPage',
    props: true,
    beforeEnter(to, from, next) {
      axios(config).then((result) => {
        var IsWebSiteView = result.data.WebSiteView

        if (IsWebSiteView) {
          if (Vue.prototype.$session.get('ForceLoginpage')) {
            next()
          } else {
            next('/Home')
          }
        } else {
          next()
        }
      })
    },
  },
  { path: '/Home', component: WebsiteView, name: 'WebsiteView' },
  { path: '/AboutUs', component: AboutUs, name: 'AboutUs' },
  { path: '/Transaction', component: Transaction, name: 'Transaction' },
  { path: '*', redirect: { name: 'LoginPage' } },

  {
    path: '/Verify/:Status',
    component: Verify,
    name: 'Verify',
    props: true,
    query: true,
  },
  {
    path: '/DetailUssd/:Status',
    component: DetailUssd,
    name: 'DetailUssd',
    props: true,
    query: true,
  },
  {
    path: '/HampaPay/:Status',
    component: HampaPay,
    name: 'HampaPay',
    props: true,
    query: true,
  },

  {
    path: '/PishkhanNetPa',
    component: PishkhanNetPa,
    name: 'PishkhanNetPa',
    meta: { requiresAuth: false },
    children: [
      {
        path: 'Accounts',
        component: Accounts,
        name: 'Accounts',
        beforeEnter(to, from, next) {
          if (from.name == 'Turnover' || from.name == 'Deposit') {
            if (Vue.prototype.$session.get('UserFromAccount')) {
              Vue.prototype.$session.set('UserFromAccount', [Vue.prototype.$session.get('UserFromAccount')[0], true])
            }
          }

          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'Accounts')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },

      {
        path: 'Funds',
        component: Funds,
        name: 'Funds',
        beforeEnter(to, from, next) {
          if (from.name == 'Turnover' || from.name == 'Deposit') {
            if (Vue.prototype.$session.get('UserFromAccount')) {
              Vue.prototype.$session.set('UserFromAccount', [Vue.prototype.$session.get('UserFromAccount')[0], true])
            }
          }

          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'Funds')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      { path: 'Home', component: NetpaHome, name: 'Home' },
      { path: 'LoanRequest', component: RequestVam, name: 'LoanRequest' },
      { path: 'loanFollowup', component: loanFollowup, name: 'loanFollowup' },
      { path: 'TablooElanat', component: TablooElanat, name: 'TablooElanat' },
      { path: 'PrintBargeSaham', component: PrintBargeSaham, name: 'PrintBargeSaham', props: true, query: true },
      { path: 'SendMessageToAdmin', component: SendMessageToAdmin, name: 'SendMessageToAdmin' },
      {
        path: 'loan',
        component: loan,
        name: 'loan',
        beforeEnter(to, from, next) {
          if (from.name == 'Turnover' || from.name == 'LoanCardex' || from.name == 'Deposit') {
            if (Vue.prototype.$session.get('UserFromLoan')) {
              Vue.prototype.$session.set('UserFromLoan', [Vue.prototype.$session.get('UserFromLoan')[0], true])
            }
          }

          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'loan')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      { path: 'Turnover', component: Turnover, name: 'Turnover', props: true },
      { path: 'Deposit', component: Deposit, name: 'Deposit', props: true },
      { path: 'SafteElectronic', component: SafteElectronic, name: 'SafteElectronic', props: true },
      {
        path: 'Debtor',
        component: Debtor,
        name: 'Debtor',
        props: true,
        beforeEnter(to, from, next) {
          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'Debtor')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      {
        path: 'LoanCardex',
        component: LoanCardex,
        name: 'LoanCardex',
        props: true,
        beforeEnter(to, from, next) {
          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'LoanCardex')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      {
        path: 'DebtorReport',
        component: DebtorReport,
        name: 'DebtorReport',
        props: true,
        beforeEnter(to, from, next) {
          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'DebtorReport')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      {
        path: 'Transfer',
        component: Transfer,
        name: 'Transfer',
        props: true,
        beforeEnter(to, from, next) {
          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'Transfer')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      {
        path: 'UserInfo',
        component: UserInfo,
        name: 'UserInfo',
        props: true,
        beforeEnter(to, from, next) {
          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'UserInfo')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      {
        path: 'Accessability',
        component: Accessability,
        name: 'Accessability',
        props: true,
        beforeEnter(to, from, next) {
          // console.log("ISRAHBAR",Vue.prototype.$session.get('IsRahbar'));
          if (Vue.prototype.$session.get('IsRahbar') == false) {
            next('/PishkhanNetPa/Home')
          } else {
            next()
          }
        },
      },
      {
        path: 'WebSiteSetting',
        component: WebSiteSetting,
        name: 'WebSiteSetting',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('IsRahbar') == false) {
            next('/PishkhanNetPa/Home')
          } else {
            next()
          }
        },
      },
      {
        path: 'Gateway',
        component: Gateway,
        name: 'Gateway',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('IsRahbar') == false) {
            next('/PishkhanNetPa/Home')
          } else {
            next()
          }
        },
      },
      {
        path: 'UsersSetting',
        component: UsersSetting,
        name: 'UsersSetting',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('IsRahbar') == false) {
            next('/PishkhanNetPa/Home')
          } else {
            next()
          }
        },
      },
      {
        path: 'GuaranteeReport',
        component: GuaranteeReport,
        name: 'GuaranteeReport',
        beforeEnter(to, from, next) {
          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'GuaranteeReport')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      {
        path: 'BlockedReport',
        component: BlockedReport,
        name: 'BlockedReport',
        beforeEnter(to, from, next) {
          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'BlockedReport')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      {
        path: 'OnlinePaymentReport',
        component: OnlinePaymentReport,
        name: 'OnlinePaymentReport',
        beforeEnter(to, from, next) {
          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'OnlinePaymentReport')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      {
        path: 'DepositGroup',
        component: DepositGroup,
        name: 'DepositGroup',
        beforeEnter(to, from, next) {
          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'DepositGroup')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
      {
        path: 'Cart',
        component: Cart,
        name: 'Cart',
        beforeEnter(to, from, next) {
          next()
        },
      },
      {
        path: 'ManagUsers',
        component: ManagUsers,
        name: 'ManagUsers',
        props: true,
        beforeEnter(to, from, next) {
          if (Vue.prototype.$session.get('ModirShobe') == false) {
            next('/PishkhanNetPa/Home')
          } else {
            next()
          }
        },
      },
      {
        path: 'Cheque',
        component: Cheque,
        name: 'Cheque',
        beforeEnter(to, from, next) {
          next()
        },
      },
      {
        path: 'RegisterUser',
        component: RegisterUser,
        name: 'RegisterUser',
        props: true,
        beforeEnter(to, from, next) {
          var access = Vue.prototype.$session.get('AccessMenu').filter((x) => x.routeName == 'RegisterUser')
          if (access.length == 1) {
            if (!access[0].isMenu) {
              next('/PishkhanNetPa/Home')
            } else {
              next()
            }
          }
        },
      },
    ],
  },
  { path: '/Rememberpassword', component: Rememberpassword, name: 'Rememberpassword', meta: { requiresAuth: false } },
  { path: '/RememberPasswordHampa', component: RememberPasswordHampa, name: 'RememberPasswordHampa', meta: { requiresAuth: false } },
  { path: '/DepositWhithoutLogin', component: DepositWhithoutLogin, name: 'DepositWhithoutLogin', meta: { requiresAuth: false } },
  { path: '/Register', component: Register, name: 'Register', meta: { requiresAuth: false } },
]
console.log(routes)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
